export enum HttpHeaderNames {
  CsrfToken = 'x-csrf-token',
  ContentType = 'content-type',
  ContentDisposition = 'content-disposition',
  Authorization = 'authorization',
  Accept = 'accept',
  XRequestId = 'x-request-id',
  XTestMode = 'x-test-mode',
  XTestAuthRateLimit = 'x-test-auth-rate-limit',
  XTestHidePopups = 'x-test-hide-popups',
  XE2eRunCapability = 'x-e2e-run-capability',
  XApiClient = 'x-api-client',
  XDeviceToken = 'x-device-token',
  /** Test mode only: a Bearer session's new token pair after a sign-in method change. */
  XTestSessionAccessToken = 'x-test-session-access-token',
  XTestSessionRefreshToken = 'x-test-session-refresh-token',
  Host = 'host',
  XForwardedHost = 'x-forwarded-host',
}
